import { render, staticRenderFns } from "./ListBlog.vue?vue&type=template&id=318f1028&"
import script from "./ListBlog.vue?vue&type=script&lang=js&"
export * from "./ListBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports